// Default settings

// var token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJDbGFpbXMiOlsiUmVhZENhbGxIaXN0b3J5IiwiUmVhZERpdmVyc2lvbiIsIlJlYWRGb3J3YXJkaW5nIiwiUmVhZEdyb3VwIiwiUmVhZEdyb3VwSW5mbyIsIlJlYWRIaXN0b3J5IiwiUmVhZExlYWRlcmJvYXJkIiwiUmVhZExvZyIsIlJlYWRNZXNzYWdlIiwiUmVhZFByZXNlbmNlIiwiUmVhZFByb2ZpbGUiLCJSZWFkU2VhcmNoIiwiUmVhZFNldHRpbmdzIiwiUmVhZFN0YXRpc3RpY3MiLCJTaG93RWRpdFNjcmVlbiIsIlNob3dHcm91cFNjcmVlbiIsIlNob3dIaXN0b3J5U2NyZWVuIiwiU2hvd0hvbWVTY3JlZW4iLCJTaG93TGVhZGVyQm9hcmRTY3JlZW4iLCJTaG93UHJlc2VuY2VTY3JlZW4iLCJTaG93U2VhcmNoU2NyZWVuIiwiU2hvd1NNU1NjcmVlbiIsIlNob3dTdGF0U2NyZWVuIiwiV3JpdGVDYWxscyIsIldyaXRlRGlzcGxheU5yIiwiV3JpdGVEaXZlcnNpb24iLCJXcml0ZUZvcndhcmRpbmciLCJXcml0ZUdyb3VwIiwiV3JpdGVQcmVzZW5jZSJdLCJVc2VyTmFtZSI6IlRhaWViIEtoZXNzaWIiLCJVc2VySWQiOjE0LCJSb2xlcyI6WzEsMiwzLDRdfQ.OzKTApH-qKs49AKHCbrSV1qpve9fYTxB39Ckf7-y-Ok";
// let server = 'http://localhost:3000';
// let logo = 'https://teleoffice.se/wp-content/uploads/2020/10/TeleOffice_Logga_Text_2-copy.png';
// let devServer = 'http://localhost:3000';
// let slaMail = 24; // hours
// let slaSocialMedia = 1; // hours
// let returnWebsite = 'https://www.teleoffice.se'  // The back arrow if you are on the primary group site
// let company = 'TeleOffice'


// Customer unique SkellefteaTax
/*
 token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJDbGFpbXMiOlsiUmVhZERpdmVyc2lvbiIsIlJlYWRGb3J3YXJkaW5nIiwiUmVhZEdyb3VwIiwiUmVhZEdyb3VwSW5mbyIsIlJlYWRIaXN0b3J5IiwiUmVhZExlYWRlcmJvYXJkIiwiUmVhZExvZyIsIlJlYWRNZXNzYWdlIiwiUmVhZFByZXNlbmNlIiwiUmVhZFByb2ZpbGUiLCJSZWFkU2VhcmNoIiwiUmVhZFNldHRpbmdzIiwiUmVhZFN0YXRpc3RpY3MiLCJSZWFkU3RhdGlzdGljc01haW4iLCJXcml0ZUNhbGxzIiwiV3JpdGVEaXNwbGF5TnIiLCJXcml0ZURpdmVyc2lvbiIsIldyaXRlRm9yd2FyZGluZyIsIldyaXRlR3JvdXAiLCJXcml0ZVByZXNlbmNlIl0sIlVzZXJOYW1lIjoiIVRlc3QxIiwiVXNlcklkIjoyLCJSb2xlcyI6WzMsNF19.VZOGUW-Z6ZNJwc5i9m5MyQxrUIZ9GmaKHoQYzXryCjA'; 
 server = 'https://swyx.skellefteataxi.se/';
 logo = 'https://www.skellefteataxi.se/wp-content/uploads/2019/02/logo_x2.png';
 devServer = 'https://nodeapi.skellefteataxi.se:3000';
 slaMail = 24; // hours
 slaSocialMedia = 1; // hours
 returnWebsite = 'https://www.teleoffice.se'  // The back arrow if you are on the primary group site
 company = 'Skellefteå Taxi'
*/


// Mind

 let token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJDbGFpbXMiOlsiUmVhZEFiYW5kb25lZCIsIlJlYWRDYWxsSGlzdG9yeSIsIlJlYWREaXZlcnNpb24iLCJSZWFkRmF2b3JpdGVzIiwiUmVhZEZvcndhcmRpbmciLCJSZWFkR3JvdXAiLCJSZWFkR3JvdXBJbmZvIiwiUmVhZEhpc3RvcnkiLCJSZWFkTGVhZGVyYm9hcmQiLCJSZWFkTWVzc2FnZSIsIlJlYWRQcmVzZW5jZSIsIlJlYWRQcm9maWxlIiwiUmVhZFNlYXJjaCIsIlJlYWRTZXR0aW5ncyIsIlJlYWRTbWFsbFNlYXJjaCIsIlJlYWRTdGF0aXN0aWNzIiwiUmVhZFN0YXR2aWV3IiwiUmVhZFVzZXJTZXR0aW5ncyIsIlNldFBhc3N3b3JkIiwiU2hvd0VkaXRTY3JlZW4iLCJTaG93R3JvdXBTY3JlZW4iLCJTaG93SGlzdG9yeVNjcmVlbiIsIlNob3dIb21lU2NyZWVuIiwiU2hvd0xlYWRlckJvYXJkU2NyZWVuIiwiU2hvd1ByZXNlbmNlU2NyZWVuIiwiU2hvd1NlYXJjaFNjcmVlbiIsIlNob3dTTVNTY3JlZW4iLCJTaG93U3RhdFNjcmVlbiIsIldyaXRlRGlzcGxheU5yIiwiV3JpdGVEaXZlcnNpb24iLCJXcml0ZUZhdm9yaXRlcyIsIldyaXRlRm9yd2FyZGluZyIsIldyaXRlR3JvdXAiLCJXcml0ZVNldHRpbmdzIiwiV3JpdGVVc2VyU2V0dGluZ3MiXSwiVXNlck5hbWUiOiIhVGVzdCIsIlVzZXJJZCI6MywiUm9sZXMiOlsxXX0.NJhB5G0q0d-5n-_lzfMTIAvRFBziKOCGq1-SSlDpGoM";
 let server = 'https://customerfirst.swyx.se:3000'; // is prob not used
 let logo = 'https://chat.mind.se/img/mind.svg';
 let devServer = 'https://mindchat.swyx.se'; //use this for mind
//  let devServer = 'https://customerfirst.swyx.se:3000'; //use this for customerfirst dev
 let slaMail = 24; // hours
 let slaSocialMedia = 1; // hours
 let returnWebsite = 'https://mind.se'  // The back arrow if you are on the primary group site
 let company = 'Mind'
// Mind

let customer = {
    tele: '90 101',
    email: 'info@mind.se',
    group: 2,
    primaryColor: '#f17509',
    showProfilePictures: false,
    showCustomerNameInHeader: true,
    showCallback: false,
    showBooking: false,
    showMail: false,
    showChat: true,
    goToUrlOnClose: true,
    showFaq: false,
    autostartChat: true,
    iconToggle: ['chat', 'find_in_page','phone'],
    textToggleTop: ['boka taxi','läsa vår faq','chatta med oss','kontakta oss'],
    phoneText: 'Vi har öppet 24/7',
    canMinimize: false,
    spacialDesignForMind: true,
    requiredToGiveEmail: false,
    notification: {
        active: true,
        url: 'https://mind.se/chatt/',
        icon: 'https://media-exp1.licdn.com/dms/image/C4E0BAQGayztS19vkuQ/company-logo_200_200/0/1637935968283?e=2159024400&v=beta&t=iGFsFStgyu1MlagBU-8sxsR6uETavOPYLx_r9vq01Kw',
        title: 'Chatt-Mind'
    },
    // uniqueChat: '9addeb49-a6f0-48cb-b3d2-af6c51f27f4c', //minds övningslinje
    // uniqueChat: '0d31c284-4439-456d-b0b5-d75fa9aa204f', //customerfirst livslinjen
    // uniqueChat: '0d31c284-4439-456d-b0b5-d75fa9aa204f', //mind livslinjen
    uniqueChat: 'd0583fca-a322-49da-bf6e-2cad829f378f', //mind självmordslinjen
    queueName: 'Självmordslinjen',
    survey: {
        preSurvey: {
            active: false,
            surveyId: 19
        },
        postSurvey: {
            active: true,
            surveyId: 21
        }
    }
} 


/* 
   uniqueChat: 'd0583fca-a322-49da-bf6e-2cad829f378f',
    queueName: 'Självmordslinjen'
*/


//  let token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJDbGFpbXMiOlsiUmVhZEFiYW5kb25lZCIsIlJlYWRDYWxsSGlzdG9yeSIsIlJlYWREaXZlcnNpb24iLCJSZWFkRmF2b3JpdGVzIiwiUmVhZEZvcndhcmRpbmciLCJSZWFkR3JvdXAiLCJSZWFkR3JvdXBJbmZvIiwiUmVhZEhpc3RvcnkiLCJSZWFkTGVhZGVyYm9hcmQiLCJSZWFkTWVzc2FnZSIsIlJlYWRQcmVzZW5jZSIsIlJlYWRQcm9maWxlIiwiUmVhZFNlYXJjaCIsIlJlYWRTZXR0aW5ncyIsIlJlYWRTbWFsbFNlYXJjaCIsIlJlYWRTdGF0aXN0aWNzIiwiUmVhZFN0YXR2aWV3IiwiUmVhZFVzZXJTZXR0aW5ncyIsIlNldFBhc3N3b3JkIiwiU2hvd0VkaXRTY3JlZW4iLCJTaG93R3JvdXBTY3JlZW4iLCJTaG93SGlzdG9yeVNjcmVlbiIsIlNob3dIb21lU2NyZWVuIiwiU2hvd0xlYWRlckJvYXJkU2NyZWVuIiwiU2hvd1ByZXNlbmNlU2NyZWVuIiwiU2hvd1NlYXJjaFNjcmVlbiIsIlNob3dTTVNTY3JlZW4iLCJTaG93U3RhdFNjcmVlbiIsIldyaXRlRGlzcGxheU5yIiwiV3JpdGVEaXZlcnNpb24iLCJXcml0ZUZhdm9yaXRlcyIsIldyaXRlRm9yd2FyZGluZyIsIldyaXRlR3JvdXAiLCJXcml0ZVNldHRpbmdzIiwiV3JpdGVVc2VyU2V0dGluZ3MiXSwiVXNlck5hbWUiOiIhVGVzdCIsIlVzZXJJZCI6MywiUm9sZXMiOlsxXX0.NJhB5G0q0d-5n-_lzfMTIAvRFBziKOCGq1-SSlDpGoM";
//  let server = 'https://mind.swyx.se/';
//  let logo = 'https://www.beijerbygg.se/wcsstore/StorefrontAssetStoreB2C/assets/dist/img/logo.svg';
//  let devServer = 'http://localhost:3000';
//  let slaMail = 24; // hours
//  let slaSocialMedia = 1; // hours
//  let returnWebsite = 'https://beijer.se'  // The back arrow if you are on the primary group site
//  let company = 'Beijer'


// //  Beijer 

//  let customer = {
//     tele: '0910 173 10',
//     email: 'info@beijer.se',
//     group: 2,
//     primaryColor: '#ffd143',
//     showProfilePictures: false,
//     showCustomerNameInHeader: true,
//     showCallback: false,
//     showBooking: false,
//     showMail: false,
//     showChat: true,
//     goToUrlOnClose: false,
//     showFaq: false,
//     autostartChat: false,
//     iconToggle: ['chat', 'find_in_page','phone'],
//     textToggleTop: ['boka taxi','läsa vår faq','chatta med oss','kontakta oss'],
//     phoneText: 'Vi har öppet 24/7',
//     canMinimize: true,
//     spacialDesignForMind: false,
//     requiredToGiveEmail: true,
// } 


/*
 server = 'https://swyx.skellefteataxi.se/';
 logo = 'https://om.tele2.se/wp-content/uploads/2017/02/tele2-og.jpg';
 devServer = 'https://srv01.teleoffice.se:3000';
 slaMail = 24; // hours
 slaSocialMedia = 1; // hours
 returnWebsite = 'https://www.tele2.se'  // The back arrow if you are on the primary group site
 company = 'Tele2 Kundservice'


 server = ' https://tele2.swyx.se/';
 logo = 'https://www.kinnarps.se/store/Static/img/logo.svg';
 devServer = 'https://tele2.swyx.se:3000';
 slaMail = 24; // hours
 slaSocialMedia = 1; // hours
 returnWebsite = 'https://www.kinnarps.se'  // The back arrow if you are on the primary group site
 company = 'Kinnarps'

 */

 //Finja
/*
 token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJDbGFpbXMiOlsiUmVhZERpdmVyc2lvbiIsIlJlYWRGb3J3YXJkaW5nIiwiUmVhZEdyb3VwIiwiUmVhZEdyb3VwSW5mbyIsIlJlYWRIaXN0b3J5IiwiUmVhZExlYWRlcmJvYXJkIiwiUmVhZExvZyIsIlJlYWRNZXNzYWdlIiwiUmVhZFByZXNlbmNlIiwiUmVhZFByb2ZpbGUiLCJSZWFkU2VhcmNoIiwiUmVhZFNldHRpbmdzIiwiUmVhZFN0YXRpc3RpY3MiLCJSZWFkU3RhdGlzdGljc01haW4iLCJXcml0ZUNhbGxzIiwiV3JpdGVEaXNwbGF5TnIiLCJXcml0ZURpdmVyc2lvbiIsIldyaXRlRm9yd2FyZGluZyIsIldyaXRlR3JvdXAiLCJXcml0ZVByZXNlbmNlIl0sIlVzZXJOYW1lIjoiIVRlc3QxIiwiVXNlcklkIjoyLCJSb2xlcyI6WzRdfQ.8fKNWf7VSvkJZY3cyVnxtTMztNYWc6mUl4rEP1A_jzo';
 server = 'https://finja.swyx.se';
 logo = 'https://www.finja.se/storage/ma/d81022f500b64aa9a59ac7aa6ce6abc2/d684a1d75723487fad99ac47157f5627/png/CD53246E58CA86518AD67F59FCF9734FDDEC627C/Finja-logo.png';
 devServer = 'https://finja.swyx.se:3000';
 slaMail = 24; // hours
 slaSocialMedia = 1; // hours
 returnWebsite = 'https://www.teleoffice.se'  // The back arrow if you are on the primary group site
 company = 'Finja'

*/
 /* // Camfil
  token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJDbGFpbXMiOlsiUmVhZERpdmVyc2lvbiIsIlJlYWRGb3J3YXJkaW5nIiwiUmVhZEdyb3VwIiwiUmVhZEdyb3VwSW5mbyIsIlJlYWRIaXN0b3J5IiwiUmVhZExlYWRlcmJvYXJkIiwiUmVhZExvZyIsIlJlYWRNZXNzYWdlIiwiUmVhZFByZXNlbmNlIiwiUmVhZFByb2ZpbGUiLCJSZWFkU2VhcmNoIiwiUmVhZFNldHRpbmdzIiwiUmVhZFN0YXRpc3RpY3MiLCJSZWFkU3RhdGlzdGljc01haW4iLCJXcml0ZUNhbGxzIiwiV3JpdGVEaXNwbGF5TnIiLCJXcml0ZURpdmVyc2lvbiIsIldyaXRlRm9yd2FyZGluZyIsIldyaXRlR3JvdXAiLCJXcml0ZVByZXNlbmNlIl0sIlVzZXJOYW1lIjoiIVRlc3QxIiwiVXNlcklkIjoyLCJSb2xlcyI6WzRdfQ.8fKNWf7VSvkJZY3cyVnxtTMztNYWc6mUl4rEP1A_jzo';
  server = 'https://camfil.swyx.se';
  logo = 'https://www.camfil.com/-/media/project/camfilcom/camfil-logo.svg?iar=0&rev=-1&hash=73A3ABDBA4AB78C8EF923BA7FFC762D0';
  devServer = 'https://camfil.swyx.se:3000';
  slaMail = 24; // hours
  slaSocialMedia = 1; // hours
  returnWebsite = 'https://www.camfil.se'  // The back arrow if you are on the primary group site
  company = 'Camfil'
*/

 // Customer unique
/*
 token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJDbGFpbXMiOlsiUmVhZEFiYW5kb25lZCIsIlJlYWRDYWxsSGlzdG9yeSIsIlJlYWREaXZlcnNpb24iLCJSZWFkRmF2b3JpdGVzIiwiUmVhZEZvcndhcmRpbmciLCJSZWFkR3JvdXAiLCJSZWFkR3JvdXBJbmZvIiwiUmVhZEhpc3RvcnkiLCJSZWFkTGVhZGVyYm9hcmQiLCJSZWFkTWVzc2FnZSIsIlJlYWRQcmVzZW5jZSIsIlJlYWRQcm9maWxlIiwiUmVhZFNlYXJjaCIsIlJlYWRTZXR0aW5ncyIsIlJlYWRTbWFsbFNlYXJjaCIsIlJlYWRTdGF0aXN0aWNzIiwiUmVhZFN0YXR2aWV3IiwiUmVhZFVzZXJTZXR0aW5ncyIsIlNldFBhc3N3b3JkIiwiU2hvd0VkaXRTY3JlZW4iLCJTaG93R3JvdXBTY3JlZW4iLCJTaG93SGlzdG9yeVNjcmVlbiIsIlNob3dIb21lU2NyZWVuIiwiU2hvd0xlYWRlckJvYXJkU2NyZWVuIiwiU2hvd1ByZXNlbmNlU2NyZWVuIiwiU2hvd1NlYXJjaFNjcmVlbiIsIlNob3dTTVNTY3JlZW4iLCJTaG93U3RhdFNjcmVlbiIsIldyaXRlRGlzcGxheU5yIiwiV3JpdGVEaXZlcnNpb24iLCJXcml0ZUZhdm9yaXRlcyIsIldyaXRlRm9yd2FyZGluZyIsIldyaXRlR3JvdXAiLCJXcml0ZVNldHRpbmdzIiwiV3JpdGVVc2VyU2V0dGluZ3MiXSwiVXNlck5hbWUiOiJLcmlzdG9mZXIgw5ZzdGx1bmQiLCJVc2VySWQiOjIwMDIsIlJvbGVzIjpbMV19.oSJUHjvCfu_H95PC0PXuMx1qeWpOLyFdvXMVJeZNtCY';
 server = 'https://swyx.responda.se';
 logo = 'https://www.responda.se/wp-content/themes/brandson-wordpress-theme_3.2/images/logo.png';
 devServer = 'https://responda.swyx.se:3000';
 slaMail = 24; // hours
 slaSocialMedia = 1; // hours
 returnWebsite = 'https://responda.se'  // The back arrow if you are on the primary group site
 company = 'Responda'
 */
 
// Custumer unique



/*let customer = {
    tele: '0910 173 10',
    email: 'info@kinnarps.se',
    group: 2,
    primaryColor: '#0166b0',
    showProfilePictures: false,
    showCustomerNameInHeader: true,
    showCallback: true,
    showBooking: false,
    showMail: false,
    showChat: true,
    showContactCenter: false,
    iconToggle: ['chat', 'email', 'find_in_page','phone'],
    textToggleTop: ['starta ärende','läsa vår faq','chatta med oss','kontakta oss'],
    phoneText: 'Vi har öppet 24/7'
} */

// Skellefteaå Taxi
// let customer = {
//     tele: '0910 173 10',
//     email: 'bokning@skellefteataxi.se',
//     group: 2,
//     primaryColor: '#33308b',
//     showProfilePictures: false,
//     showCustomerNameInHeader: true,
//     showCallback: false,
//     showBooking: true,
//     showMail: false,
//     showChat: true,
//     showFaq: true,
//     iconToggle: ['chat', 'local_taxi', 'find_in_page','phone'],
//     textToggleTop: ['boka taxi','läsa vår faq','chatta med oss','kontakta oss'],
//     phoneText: 'Vi har öppet 24/7'
// } 

// lensway
/*
let customer = {
    tele: '020 23 20 20',
    email: 'info@lensway.se',
    group: 2,
    primaryColor: '#ec2027',
    showProfilePictures: false,
    showCustomerNameInHeader: true,
    showCallback: false,
    showBooking: false,
    showMail: true,
    showChat: true,
    showFaq: true,
    iconToggle: ['chat', 'find_in_page','phone'],
    textToggleTop: ['ställa frågor','skicka in ett mejl','chatta med oss','kontakta oss'],
    phoneText: 'Vi har öppet 24/7'
} */

// finja
/*
let customer = {
    tele: '010-455 21 21',
    email: 'order@finja.se',
    group: 2,
    primaryColor: '#0166b0',
    showProfilePictures: false,
    showCustomerNameInHeader: true,
    showCallback: false,
    showBooking: false,
    showMail: true,
    mailToLink: true,
    mailToMailtoLink: 'order@finja.se',
    showChat: true,
    showContactCenter: false,
    showFaq: false,
    iconToggleView: true,
    iconToggle: ['chat', 'find_in_page','phone'],
    textToggleTop: ['ställa frågor','skicka in ett mejl','chatta med oss','kontakta oss'],
    phoneText: 'Kontaktuppgifter',
    showMailText: ''
} */


 /*
 token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJDbGFpbXMiOlsiUmVhZEFiYW5kb25lZCIsIlJlYWRDYWxsSGlzdG9yeSIsIlJlYWREaXZlcnNpb24iLCJSZWFkRmF2b3JpdGVzIiwiUmVhZEZvcndhcmRpbmciLCJSZWFkR3JvdXAiLCJSZWFkR3JvdXBJbmZvIiwiUmVhZEhpc3RvcnkiLCJSZWFkTGVhZGVyYm9hcmQiLCJSZWFkTWVzc2FnZSIsIlJlYWRQcmVzZW5jZSIsIlJlYWRQcm9maWxlIiwiUmVhZFNlYXJjaCIsIlJlYWRTZXR0aW5ncyIsIlJlYWRTbWFsbFNlYXJjaCIsIlJlYWRTdGF0aXN0aWNzIiwiUmVhZFN0YXR2aWV3IiwiUmVhZFVzZXJTZXR0aW5ncyIsIlNldFBhc3N3b3JkIiwiU2hvd0VkaXRTY3JlZW4iLCJTaG93R3JvdXBTY3JlZW4iLCJTaG93SGlzdG9yeVNjcmVlbiIsIlNob3dIb21lU2NyZWVuIiwiU2hvd0xlYWRlckJvYXJkU2NyZWVuIiwiU2hvd1ByZXNlbmNlU2NyZWVuIiwiU2hvd1NlYXJjaFNjcmVlbiIsIlNob3dTTVNTY3JlZW4iLCJTaG93U3RhdFNjcmVlbiIsIldyaXRlRGlzcGxheU5yIiwiV3JpdGVEaXZlcnNpb24iLCJXcml0ZUZhdm9yaXRlcyIsIldyaXRlRm9yd2FyZGluZyIsIldyaXRlR3JvdXAiLCJXcml0ZVNldHRpbmdzIiwiV3JpdGVVc2VyU2V0dGluZ3MiXSwiVXNlck5hbWUiOiJSb2dlciBIw7ZqZW5kYWwiLCJVc2VySWQiOjIwMDIsIlJvbGVzIjpbMV19.tUses3H1V6DqUXEzJ6N4cszQnGuTzg5zOtjnmnRekqg';
 server = 'https://skekraft.swyx.se';
 logo = 'https://upload.wikimedia.org/wikipedia/en/thumb/7/73/Skellefte%C3%A5_Kraft_logo.svg/1235px-Skellefte%C3%A5_Kraft_logo.svg.png';
 devServer = 'https://skekraft.swyx.se:3000';
 slaMail = 24; // hours
 slaSocialMedia = 1; // hours
 returnWebsite = 'https://www.teleoffice.se'  // The back arrow if you are on the primary group site
 company = 'Skellefteå Kraft'
*/

/*let customer = {
    tele: '0910-77 25 00',
    email: 'info@skekraft.se',
    group: 2,
    primaryColor: '#702082',
    showProfilePictures: false,
    showCustomerNameInHeader: true,
    showCallback: false,
    showBooking: false,
    showMail: true,
    mailToLink: false,
    mailToMailtoLink: 'order@finja.se',
    showChat: true,
    showContactCenter: false,
    showFaq: true,
    iconToggle: ['chat', 'find_in_page','phone'],
    textToggleTop: ['ställa frågor','skicka in ett mejl','chatta med oss','kontakta oss'],
    phoneText: 'Kontaktuppgifter',
    showMailText: ''
} */

/*
let customer = {
    tele: '0156-537 00',
    email: 'info@camfil.com',
    group: 2,
    primaryColor: '#046643',
    showProfilePictures: false,
    showCustomerNameInHeader: true,
    showCallback: true,
    showBooking: false,
    showMail: false,
    showChat: true,
    showContactCenter: false,
    showFaq: true,
    iconToggle: ['chat', 'find_in_page','phone'],
    textToggleTop: ['ställa frågor','skicka in ett mejl','chatta med oss','kontakta oss'],
    phoneText: 'Kontaktuppgifter',
    showMailText: ''
} */




/*let customer = {
    tele: '0910 173 10',
    email: 'info@responda.se',
    group: 2,
    primaryColor: '#f8b406',
    showProfilePictures: false,
    showCustomerNameInHeader: true,
    showCallback: false,
    showBooking: false,
    showFaq: true,
    showMail: true,
    showChat: true,
    iconToggleView: false,
    iconToggle: ['chat', 'find_in_page','phone'],
    textToggleTop: ['boka taxi','läsa vår faq','chatta med oss','kontakta oss'],
    phoneText: 'Begär callback'
} */


/*customer = {
    tele: '+4684590000',
    email: 'info@teleoffice.se',
    group: 492,
    primaryColor: '#0e1b8d',
    showProfilePictures: false,
    showCustomerNameInHeader: true,
    showCallback: true,
    showBooking: false,
    showChat: true,
    showMail: true,
    iconToggle: ['chat', 'find_in_page','phone'],
    textToggleTop: ['boka taxi','läsa vår faq','chatta med oss','kontakta oss'],
    phoneText: 'Begär callback'
}*/





export default {
    returnWebsite,
    slaMail,
    slaSocialMedia,
    token,
    server,
    logo,
    devServer,
    company,
    customer
}